import React from "react";

const TermsAndConditionPdf = ({ terms }) => {
  return (
    <div className="pdfpadding pdftermsbox">
      <h2>Terms & Conditions</h2>

      <div style={{ margin: "1px 0px",padding:'0px 20px', maxHeight: "57mm",overflow: "hidden",}}>
        <p
          dangerouslySetInnerHTML={{ __html: terms }}
          style={{ fontSize: "12px" }}
        ></p>
      </div>
    </div>
  );
};

export default TermsAndConditionPdf;
